module.exports = __webpack_public_path__ + "img/quest-fail.136b7d30.png";